export default {
  instagramUrl: 'https://www.instagram.com/hairstyliste.lisa/',
  whatsappUrl: 'https://wa.me/31623412225',

  prices: [{
    "title": "Lady Shorty (kort koppie)",
    "features": ["wassen", "knippen", "drogen"],
    "price": 33
  }, {
    "title": "Lady Deluxe",
    "features": ["wassen", "intensief haarmasker", "knippen", "model drogen"],
    "price": 38
  }, {
    "title": "Lady Premium",
    "features": ["wassen", "olaplex masker", "knippen", "stevige styling met stijl-/krultang of föhn (nieuwe look)"],
    "price": 51
  }, {
    "title": "Lady Curl short hair",
    "features": ["wassen", "masker", "krultechniek", "stylingsproducten", "diffuser"],
    "price": 51
  }, {
    "title": "Lady Curl long hair",
    "features": ["wassen", "masker", "krultechniek", "stylingsproducten", "diffuser"],
    "price": 61
  }, {
    "title": "Olaplex Herstelbehandeling 30 min",
    "features": ["zwaar beschadigd haar herstellen"],
    "price": 35
  }, {
    "padding": true,
    "title": "Men Basic",
    "features": ["wassen", "knippen", "styling"],
    "price": 27
  }, {
    "title": "Men Premium",
    "features": ["wassen", "knippen", "reshade color", "styling"],
    "price": 38
  }, {
    "padding": true,
    "title": "Kleuringen",
    "features": ["Uitgroei kleuring"],
    "price": 47
  }, {
    "title": null,
    "features": ["Volledige kleuring"],
    "price": 70
  }, {
    "title": null,
    "features": ["Kwart folie kleuring"],
    "price": 50
  }, {
    "title": null,
    "features": ["Halve folie kleuring"],
    "price": 75
  }, {
    "title": null,
    "features": ["Hele folie kleuring"],
    "price": 95
  }, {
    "title": null,
    "features": ["Ontkleuring"],
    "price": 85
  }, {
    "title": null,
    "features": ["Olaplex toevoeging"],
    "prefix": "va.",
    "price": 18
  }, {
    "title": null,
    "features": ["Toner na verven"],
    "price": 27
  }, {
    "padding": true,
    "title": "Balayage Deluxe",
    "features": ["balayage", "olaplex", "toner", "knippen", "styling"],
    "price": 178
  }, {
    "title": "Balayage Premium",
    "features": ["roots", "balayage", "olaplex", "toner", "knippen", "styling"],
    "price": 225
  }, {
    "padding": true,
    "title": "Extra",
    "features": ["Party hair"],
    "price": 45
  }, {
    "title": null,
    "features": ["Party hair + make-up"],
    "price": 80
  }, {
    "title": null,
    "features": ["Bruidskapsels"],
    "hideEuro": true,
    "price": "vanaf €300"
  }, {
    "title": null,
    "padding": true,
    "features": [""],
    "hideEuro": true,
    "price": "Alle behandelingen vanaf 10 jaar"
  }]
}
